import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const getAllClinic = createAsyncThunk(
  "clinic/getAllClinic",
  async (clinicData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinic/getAllClinic", clinicData, {
        headers: {
          "Content-Type": "application/json",
          token: clinicData.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllRegisteredUnregisteredClinic = createAsyncThunk(
  "clinic/getAllRegisteredUnregisteredClinic",
  async (clinicData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinic/getAllRegisteredUnregisteredClinic",
        clinicData,
        {
          headers: {
            "Content-Type": "application/json",
            token: clinicData.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getClinicInfo = createAsyncThunk(
  "clinic/getClinicInfo",
  async (clinicData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinic/getClinicInfo", clinicData, {
        headers: {
          "Content-Type": "application/json",
          token: clinicData.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateClinicProfileInfo = createAsyncThunk(
  "clinic/updateClinicProfileInfo",
  async ({ formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinic/updateClinicProfileInfo",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateHospitalInfo = createAsyncThunk(
  "clinic/updateHospitalInfo",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinic/updateHospitalInfo",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            token: formData.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const deleteHospitalInfoImage = createAsyncThunk(
  "clinic/delete-hospital-info-image",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        "/clinic/delete-hospital-info-image",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            token: formData.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const updateHospitalInfoFiles = createAsyncThunk(
  "clinic/updateHospitalInfoFiles",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinic/updateHospitalInfoFiles",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: formData.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateAccountInfo = createAsyncThunk(
  "clinic/updateAccountInfo",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post("/clinic/updateAccountInfo", formData, {
        headers: {
          "Content-Type": "application/json",
          token: formData.token,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updateClinic = createAsyncThunk(
  "clinic/updateClinic",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinic/updateClinicProfileInfo",
        data,
        {
          headers: {
            "content-Type": "Application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const getClinicReportName = createAsyncThunk(
  "clinic/getClinicReportName",
  async (clinicId, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/clinic/getClinicReportName",
        { clinicId },
        {
          headers: {
            "Content-Type": "application/json",
            // Add token if needed
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const ClinicDetails = createSlice({
  name: "clinicData",
  initialState: {
    loading: false,
    successMessage: null,
    errorMessage: null,
    updateSuccessMessage: null,
    updateErrorMessage: null,
    updateHospitalSuccessMessage: null,
    updateHospitalErrorMessage: null,
    updateHospitalFilesSuccessMessage: null,
    updateHospitalFilesErrorMessage: null,
    updateAccountSuccessMessage: null,
    updateAccountErrorMessage: null,
    allClinicLists: [],
    clinicInfo: [],
    searchMessage: null,
    registeredUnregisteredClinic: [],
    updateClinicSuccessMessage: null,
    updateClinicErrorMessage: null,
    deleteHospitalImageSuccessMessage: null,
    deleteHospitalImageErrorMessage: null,
    currentPage: 1,
    totalPages: null,
    hasMore: true,
    totalCount: 0,
    reportName: null,
  },
  reducers: {
    resetUpdateMessages: (state) => {
      state.updateSuccessMessage = null;
      state.updateErrorMessage = null;
    },
    resetUpdateHospitalMessages: (state) => {
      state.updateHospitalSuccessMessage = null;
      state.updateHospitalErrorMessage = null;
    },
    resetUpdateHospitalFilesMessages: (state) => {
      state.updateHospitalFilesSuccessMessage = null;
      state.updateHospitalFilesErrorMessage = null;
    },
    resetUpdateAccountMessages: (state) => {
      state.updateAccountSuccessMessage = null;
      state.updateAccountErrorMessage = null;
    },
    resetUpdateClinicMessage: (state) => {
      state.updateClinicSuccessMessage = null;
      state.updateClinicErrorMessage = null;
    },
    resetDeleteMessages: (state) => {
      state.deleteHospitalImageErrorMessage = null;
      state.deleteHospitalImageErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllClinic.pending, (state) => {
        state.loading = true;
      })
.addCase(getAllClinic.fulfilled, (state, action) => {
  state.loading = false;

  if (!action.payload.success) {
    state.allClinicLists = [];
    state.totalCount = 0;
    state.totalPages = 1;
    state.searchMessage =
      action.payload.result?.message || "No data found";
    return;
  }

  const result = action.payload.result;

  state.allClinicLists = result.list || [];
  state.currentPage = Number(result.currentPage) || 1;
  state.totalPages = Number(result.totalPages) || 1;
  state.totalCount = Number(result.totalRecords) || 0;
  state.hasMore = result.hasMore ?? false;
  state.searchMessage = null;
})


      .addCase(getAllClinic.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload || "Failed to fetch clinic data";
      })
      .addCase(getClinicInfo.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClinicInfo.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.clinicInfo = action.payload.result.list;
        } else {
          state.errorMessage = action.payload.result.message;
        }
      })
      .addCase(getClinicInfo.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload || "Failed to fetch clinic info";
      })
      .addCase(updateClinicProfileInfo.pending, (state) => {
        state.loading = true;
        state.updateSuccessMessage = null;
        state.updateErrorMessage = null;
      })
      .addCase(updateClinicProfileInfo.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateErrorMessage = action.payload.result.message;
        } else {
          state.updateSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateClinicProfileInfo.rejected, (state, action) => {
        state.loading = false;
        state.updateErrorMessage = action.payload.result.message;
      })
      .addCase(updateHospitalInfo.pending, (state) => {
        state.loading = true;
        state.updateHospitalSuccessMessage = null;
        state.updateHospitalErrorMessage = null;
      })
      .addCase(updateHospitalInfo.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateHospitalErrorMessage = action.payload.result.message;
        } else {
          state.updateHospitalSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateHospitalInfo.rejected, (state, action) => {
        state.loading = false;
        state.updateHospitalErrorMessage = action.payload.result.message;
      })
      .addCase(updateHospitalInfoFiles.pending, (state) => {
        state.loading = true;
        state.updateHospitalFilesSuccessMessage = null;
        state.updateHospitalFilesErrorMessage = null;
      })
      .addCase(updateHospitalInfoFiles.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateHospitalFilesErrorMessage = action.payload.result.message;
        } else {
          state.updateHospitalFilesSuccessMessage =
            action.payload.result.message;
        }
      })
      .addCase(updateHospitalInfoFiles.rejected, (state, action) => {
        state.loading = false;
        state.updateHospitalFilesErrorMessage = action.payload.result.message;
      })
      .addCase(updateAccountInfo.pending, (state) => {
        state.loading = true;
        state.updateAccountSuccessMessage = null;
        state.updateAccountErrorMessage = null;
      })
      .addCase(updateAccountInfo.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateAccountErrorMessage = action.payload.result.message;
        } else {
          state.updateAccountSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateAccountInfo.rejected, (state, action) => {
        state.loading = false;
        state.updateAccountErrorMessage = action.payload.result.message;
      })
      .addCase(updateClinic.pending, (state) => {
        state.loading = true;
        state.updateClinicSuccessMessage = null;
        state.updateClinicErrorMessage = null;
      })
      .addCase(updateClinic.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.updateClinicErrorMessage = action.payload.result.message;
        } else {
          state.updateClinicSuccessMessage = action.payload.result.message;
        }
      })
      .addCase(updateClinic.rejected, (state, action) => {
        state.loading = false;
        state.updateClinicErrorMessage = action.payload.result.message;
      })
      .addCase(getAllRegisteredUnregisteredClinic.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getAllRegisteredUnregisteredClinic.fulfilled,
        (state, action) => {
          state.loading = false;
          if (action.payload.success) {
            state.registeredUnregisteredClinic = action.payload.result.list;
          } else {
            state.errorMessage = action.payload.result.message;
          }
        }
      )
      .addCase(getAllRegisteredUnregisteredClinic.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload || "Failed to fetch clinic data";
      })
      .addCase(deleteHospitalInfoImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteHospitalInfoImage.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === true) {
          state.deleteHospitalImageSuccessMessage =
            action.payload.result.message;
        } else {
          state.deleteHospitalImageErrorMessage = action.payload.result.message;
        }
      })
      .addCase(deleteHospitalInfoImage.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getClinicReportName.pending, (state) => {
        state.loading = true;
      })
      .addCase(getClinicReportName.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success) {
          state.reportName = action.payload.result;
        } else {
          state.errorMessage = action.payload.result;
        }
      })
      .addCase(getClinicReportName.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload || "Failed to fetch report name";
      });
  },
});
export const {
  resetUpdateHospitalFilesMessages,
  resetUpdateHospitalMessages,
  resetUpdateMessages,
  resetUpdateClinicMessage,
  resetUpdateAccountMessages,
  resetDeleteMessages,
} = ClinicDetails.actions;
export default ClinicDetails.reducer;
